<script>
import {defineComponent} from "vue";
import DefaultTitle from "../small_components/DefaultTitle.vue";
import Loader from "../small_components/Loader.vue";
import RouterLinkTo from "../small_components/RouterLinkTo.vue";
import SmallTitle from "../small_components/SmallTitle.vue";
import GrayText from "../small_components/GrayText.vue";
import DefaultBox from "../slots/DefaultBox.vue";
import SiteStatusStatistic from "../parts/Dashboard/Administrator/SiteStatusStatistic.vue";

export default defineComponent({
  name: "StatisticLayout",
  components: {SiteStatusStatistic, DefaultTitle, Loader, RouterLinkTo, SmallTitle, GrayText, DefaultBox}
})
</script>

<template>
  <div class="users-layout">
      <site-status-statistic/>
  </div>
</template>

<style scoped>

</style>